var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-table',{staticClass:"zy-table",attrs:{"data":_vm.data,"height":_vm.height,"span-method":_vm.objectSpanMethod,"header-cell-style":_vm.headerCellStyle,"header-row-style":_vm.headerRowStyle,"cell-style":_vm.cellStyle,"row-style":_vm.rowStyle}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }